var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"th col",class:{
    [`col-${_vm.cols}`]: !!_vm.cols,
    top: _vm.borderTop,
    no_border: _vm.noBorder
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }